angular
	.module 'App.Component'
	.component 'clipboardCopy',
	{
		templateUrl: '@component/clipboard-copy/clipboard-copy.view.html'
		controller: 'ClipboardCopyComponent'
		controllerAs: 'clipboardCopy'
		bindings:
			text: '<'
			label: '<?'
	}

class ClipboardCopyComponent extends AbstractController
	@registerController()
	@inject '$filter',
		'$timeout'
		'ToastService'

	initialize: ->
		@actionDone = false
		@label ?= @text

	onCopy: ->
		@actionDone = true
		message = @$filter('translate')('general.copied.to.clipboard').toString()
		@ToastService.add message, null, 'info'

		@$timeout(
			=>
				@actionDone = false
		,
			2000
		)
